module.exports = __webpack_public_path__ + "img/caas2m.4631cfde.jpg";